/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import {AA_CONSENT_STATUS, AA_PROCESSING_STATUS} from 'constants/AAConstants';
import {VIEW_STATES} from 'constants/AAConstants';
import {isConsentFailed, isAnalysisFailed} from './consentService';

export const determineViewState = (consent, hasExistingConsent, isLoading, showUploadOption) => {
  const {status: consentStatus, processingStatus, errorMessage} = consent || {};

  if (isLoading && !hasExistingConsent && !consentStatus) {
    return VIEW_STATES.LOADING;
  }

  if (!hasExistingConsent && !consentStatus) {
    return VIEW_STATES.INITIAL;
  }

  if (
    consentStatus === AA_CONSENT_STATUS.ACTIVE &&
    [AA_PROCESSING_STATUS.FETCHING, AA_PROCESSING_STATUS.PROCESSING].includes(processingStatus)
  ) {
    return VIEW_STATES.PROCESSING;
  }

  if (consentStatus === AA_CONSENT_STATUS.PENDING) {
    return VIEW_STATES.INITIAL;
  }

  if (
    isConsentFailed(consentStatus, processingStatus) ||
    showUploadOption ||
    isAnalysisFailed(consentStatus, processingStatus, errorMessage)
  ) {
    return VIEW_STATES.FAILED;
  }

  return VIEW_STATES.INITIAL;
};
